import { VehicleIssueStatusenum } from "../../Enum/vehicleIssue-status.enum";

export class VehicleIssueData {
  vehicleId: number | undefined;
  employeeId: number | undefined;
  title: string | undefined;
  description: string | undefined;
  fileUpload: string | undefined;
  priority: string | undefined;
  dueDate: any | undefined;
  isActive: boolean;
  vehicleStatus: VehicleIssueStatusenum;

  constructor(
    vehicleId: number | undefined,
    employeeId: number | undefined,
    title: string | undefined,
    description: string | undefined,
    fileUpload: string | undefined,
    priority: string | undefined,
    dueDate: any | undefined,
    isActive: boolean,
    vehicleStatus: VehicleIssueStatusenum
  ) {
    this.vehicleId = vehicleId;
    this.employeeId = employeeId;
    this.title = title;
    this.description = description;
    this.fileUpload = fileUpload;
    this.priority = priority;
    this.dueDate = dueDate;
    this.isActive = isActive;
    this.vehicleStatus = vehicleStatus;
  }
}
